import * as TurboModuleRegistry from "../TurboModule/TurboModuleRegistry";
var NativeAnimatedTurboModule_default = TurboModuleRegistry.get("NativeAnimatedTurboModule");
export {
  NativeAnimatedTurboModule_default as default
};
//# sourceMappingURL=NativeAnimatedTurboModule.js.map
